import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../../shared/common.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  signForm: FormGroup;
  isLogin:boolean = true;
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  adminUser: boolean = true;
  clubUser: boolean = false;
  LoginFlag: boolean = true;
  ResetFlag: boolean = false;
  Loginmessage: string = "";
  isLoading: boolean = false;
  text1=""
  constructor(private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router) { }

  ngOnInit() {
    this.initialiseForms();
    
   console.log(this.text1);
  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      userName: ["", [Validators.required]],
      password: ["", [Validators.required]]
    });
    this.signForm = this.fb.group({
      name: ["", [Validators.required]],
      type: ["", [Validators.required]],
      date: ["", [Validators.required]],
      location: ["", [Validators.required]],
      bio: ["", [Validators.required]],
      refcode: ["", [Validators.required]],
    });
  }

 

  loginFN() {
    this.router.navigate(['main/dashboard'])
  }
  SwitchLogin(value){
    if (value == 'true') {
      this.isLogin = true;
    }else {
      this.isLogin = false;
    }

  }

  login() {
// debugger
//     this.commonService.setStorage("token",'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI1ZmUyNzIzMjRlZjM2NjQ4NDczMGIzYmIiLCJyb2xlIjoidXNlciIsImVtYWlsIjoiZ2VuZWtlbGx5QG1hdGluZXQuY29tIiwic3ViUm9sZSI6IkMiLCJpYXQiOjE2MjE0MDM4MDV9.-L74PkFoJoWHV7k_3ET4mmfoVfm9bI6QBVLt-lQI-xM' );
//     this.router.navigate(['main/video/view-video'])

    this.formSubmitted = true;
    if (this.loginForm.valid) {
      let req = {
        email: this.loginForm.controls["userName"].value.trim(),
        password: this.loginForm.controls["password"].value.trim()
      };
      this.isLoading = true;
      this.authServices.validateLogin(req).subscribe((res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.commonService.setStorage("token", res.body.data.accessToken);
          this.router.navigate(['main/dashboard'])
        } else {
        }
      },
        err => {
          this.isLoading = false;
        });
    }
  }
} 
